<template>
  <div id="apply">
     <div class="success">
        <div style="color:red">提交成功</div>
        <div>审核结果将于3-7个工作日内发送至您的邮箱</div>
     </div>
     <div class="footer">
        <div>有任何疑问可添加万象小客服咨询</div>
        <img src="@/assets/vip2.png"/>
        <div>专属客服二维码</div>
        <div>其它信息其它信息其它信息</div>
     </div>

     <div class="btn" @click="skipFn()">
         返回首页
     </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
export default {
  data() {
    return {
    };
  },
  methods: {
      skipFn(){
          this.$router.push({path:'/info'})
      }
  },
};
</script>
<style scope>
.btn{
    background-color: rgba(96, 25, 133);
    border-radius: 25px;
    height: 40px;
    line-height: 40px;
    width: 130px;
    font-size: 18px;
    color:#fff;
    margin: 0 auto;
    margin-top: 140px;
    position: relative;
    
}
.footer{
    font-size: 16px;
    margin-top: 100px;
}
.footer img{
    width: 80px;
    height: 80px;
    margin-top: 20px;
    margin-bottom: 5px;
}
.footer div{
    font-size: 12px;
}
.footer div:first-child{
    font-size: 18px;
}
.success{
  padding-top: 150px;
}
.success div:last-child{
  font-size: 12px;
}
.success div:first-child{
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
}
</style>

